export let Environment;
(function (Environment) {
  Environment[Environment["local"] = 0] = "local";
  Environment[Environment["qa"] = 1] = "qa";
  Environment[Environment["prod"] = 2] = "prod";
})(Environment || (Environment = {}));